<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
<style>
  
.photo_camera {
  cursor: pointer;
  margin-left: 5px;
  font-variation-settings:
  'FILL' 0,
  'wght' 400,
  'GRAD' 0,
  'opsz' 48
}
.photo_camera:hover {
  font-variation-settings:
  'FILL' 1,
  'wght' 400,
  'GRAD' 0,
  'opsz' 48
}
</style>
<div class="activeDrafts">
  <app-active-drafts2 *ngIf="!isMobile"></app-active-drafts2>
</div>
<div class="mainContainer">
  <div class="gameHistoryTab">   
    <div class="filter1" [ngStyle]="{'flex':(isMobile)?'100%':'','width':(isMobile)?'100%':''}" >
      <span (click)="tabChange('upcoming')" class="tab" [ngClass]="{'active':currentTab=='upcoming'}" label="upcoming">Upcoming</span>
      <span (click)="tabChange('drafting')" class="tab" [ngClass]="{'active':currentTab=='drafting'}" label="active">Drafting</span>
      <span (click)="tabChange('live')" class="tab" [ngClass]="{'active':currentTab=='live'}" label="live">Live</span>
      <span (click)="tabChange('history')" class="tab" [ngClass]="{'active':currentTab=='history'}" label="history">History</span>      
    </div>
</div>

  <div class="body myteams {{browsername}}"  [ngClass]="(isMac)?'macOS':'otherOS'" [ngStyle]="{'display':(!isMobile)?'flex':''}">
    <!-- <app-game-selector page="myteams"></app-game-selector> -->
    <div class="leftSide" [ngClass]="{'expanded':currentDisplay == 'left'}" *ngIf="currentDisplay != 'right'">
      <div class="menuBar" *ngIf="(!isMobile && currentTab!='drafting' && currentTab!='upcoming') || (isMobile && currentDisplay == 'left' && currentTab!='drafting' && currentTab!='upcoming')">
        <div class="body">
          <div class="contestTypes" *ngIf="currentDisplay != 'right' && (!showStandings || !isMobile)">
            <!-- <mat-radio-group [(value)]="currentTab" (change)="tabChange($event)" class="filter1">
              <mat-radio-button class="radioBtn" value='upcoming'>Upcoming</mat-radio-button>
              <mat-radio-button class="radioBtn" value='live'>Live</mat-radio-button>
              <mat-radio-button class="radioBtn" value='history'>History</mat-radio-button>
            </mat-radio-group> -->
            <div class="filter2">
              <mat-form-field class="gameSelect" *ngIf="!isMobile">
                <mat-select placeholder="All Drafts" [(value)]="contestFilters" (selectionChange)="setType($event.value)">
                  <mat-option value="all">All Drafts</mat-option>
                  <mat-option value="cash">Cash</mat-option>
                  <mat-option value="tournament">Tournament</mat-option>
                  <mat-option value="seasons">Bestball</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="gameSelect" *ngIf="!isMobile">
                <mat-select placeholder="Sport" [(value)]="curGame" (selectionChange)="contestsReset()">
                  <mat-option *ngFor="let game of games | keyvalue" [value]="game.key">
                    {{game.value.toUpperCase()}}
                  </mat-option>
                </mat-select>
              </mat-form-field> 
              <mat-form-field class="gameSelect" *ngIf="!isMobile">
                <mat-select placeholder="Sort" [(ngModel)]="currentSort" (selectionChange)="sortContests($event.value)">
                  <mat-option value="">None</mat-option>
                  <mat-option value="fpts">FPTS</mat-option>
                  <mat-option value="winning">Winning</mat-option>
                  <mat-option value="entries">Entries</mat-option>
                  <mat-option value="entrants">Entrants</mat-option>
                  <mat-option value="fee">Entry Fee</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="filter3">
            <mat-form-field class="gameSelect" *ngIf="currentTab == 'history'">
              <mat-select placeholder="Season" [(value)]="selectedSeason" (selectionChange)="setSeason($event.value)">
                <mat-option *ngFor="let season of seasonList" [value]="season.id">{{ season.year }}</mat-option>
              </mat-select>
            </mat-form-field>
            
            <mat-form-field class="searchBar" [ngClass]="{'searchBarHistory': currentTab == 'history', 'searchBarOther': currentTab != 'history'}" *ngIf="!isMobile">
              <input type="text" matInput placeholder="Search" [(ngModel)]="contestSearch" (keyup)="searchContests()">
              <i class="close fas fa-times" *ngIf="contestSearch != ''" (click)="clearSearch()"></i>
            </mat-form-field>
          </div>
        </div>
          </div>
          </div>
          <div class="leftGameHistory" >
              <div class="heading clearfix">
                  Your Contests
                  <span *ngIf="currentTab == 'live'" class="amount">${{getCurrentlyWinning() | number:'1.2-2' | Price}}</span>
              </div>
              <mat-error *ngIf="errorMsg2!=''" class="error">{{errorMsg2}}</mat-error>
              <div [ngStyle]="{'height':getHeight(leftSide)+'px','overflow-y': 'auto'}" (scroll)="contestScroll($event)" #leftSide class="scrollTable">
                <!-- *ngIf="!showStandings || isMobile"> -->
                <ng-container *ngIf="isMobile || currentDisplay == 'both'">
                  <div class="empty" *ngIf="!displayContests.length && !loadingContests && currentTab != 'drafting'">
                    No {{currentTab}} contests
                  </div>
                  <div class="loadingContests" *ngIf="loadingContests">
                    <img src="assets/images/loading.gif">
                  </div>
                  <ng-container *ngIf="currentTab!='drafting'">
                  <ng-container *ngFor="let contest of displayContests">
                    <a class="upcoming" *ngIf="contest?.type == 'upcoming'" [href]="contestLink(contest)">
                      <div class="gameIcon"
                        [ngStyle]="{'backgroundImage':'url(\''+bucketURL+games[contest?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1\')'}"></div>
                      <div class="uName" [ngClass]="{'mini':currentDisplay == 'both'}">{{contest?.lg_name}}</div>
                        <button *ngIf="contest.is_full ==false" mat-raised-button color="danger" class="unregisterBtn unregister"
                         (click)="confirmDialog($event,contest.league_code,contest.lg_name,contest.seconds_per_pick,contest.tournament_id)">Unregister</button>
                      <div class="goto"><i class="fas fa-chevron-right"></i></div>
                    </a>
                    <div class="league" [ngClass]="{'selected':contest?.selected}" *ngIf="contest?.type == 'league'"
                      (click)="loadContest(contest?.slug)">
                      <div class="gameIcon"
                        [ngStyle]="{'backgroundImage':'url(\''+bucketURL+games[contest?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1\')'}"></div>
                      <div class="details">
                        <div class="name" [ngClass]="{'mini':currentDisplay == 'both'}">{{contest?.lg_name}}</div>
                        <div class="best" [ngClass]="{'mini':currentDisplay == 'both'}">{{contest?.team_rank}} of
                          {{contest?.entrants}}</div><br *ngIf="currentDisplay == 'both'" />
                        <div class="winning" [ngClass]="{'mini':currentDisplay == 'both'}">
                          {{(contest?.payout > 0)?'$'+(contest?.payout.toFixed(2) |  number:'1.2-2' | Price):''}}
                        </div>
                        <div class="myFpts" [ngClass]="{'mini':currentDisplay == 'both'}">
                          {{contest?.team_total.toFixed(2)}} FPTS
                        </div>
                        <div class="pmr" [ngClass]="{'mini':currentDisplay == 'both'}"
                          *ngIf="contest?.game_id != 5 && contest?.duration_id != 8">
                          <div class="pmrOuter">
                            <div class="pmrInner" [ngStyle]="getPMRStyle(contest?.pmr,contest?.total_pmr)"></div>
                            <div class="pmrNub"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tournament" *ngIf="contest?.type == 'tournament'"
                      (click)="(contest?.lgms == null)?expandTour(contest):(contest.expanded = !contest.expanded)"
                      [ngClass]="{'selected':contest?.expanded}">
                      <div class="gameIcon"
                        [ngStyle]="{'backgroundImage':'url(\''+bucketURL+games[contest?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1\')'}"></div>
                      <div class="details">
                        <div class="name" [ngClass]="{'mini':currentDisplay == 'both'}">{{contest?.name}}</div>
                        <div class="best" [ngClass]="{'mini':currentDisplay == 'both'}">{{contest?.best}} of
                          {{contest?.tour_entrants}}</div><br *ngIf="currentDisplay == 'both'" />
                        <div class="winningTour" [ngClass]="{'mini':currentDisplay == 'both'}">
                          {{(contest?.winning > 0)?'$'+contest?.winning.toFixed(2):''}}</div>
                        <div class="arrow" [ngClass]="{'mini':currentDisplay == 'both'}">{{contest?.lgm_ids.length}}
                          {{contest?.lgm_ids.length > 1 ? 'Entries' : 'Entry'}}<i class="fas fa-caret-down"></i></div>
                      </div>
                    </div>
                    <ng-container *ngIf="contest?.type == 'tournament' && contest?.expanded && contest?.lgms.length">
                      <div class="lgm" *ngFor="let lgm of contest?.lgms" (click)="loadContest(lgm.slug)">
                        <div class="details">
                          <div class="name" [ngClass]="{'mini':currentDisplay == 'both'}">{{lgm.team_name}}</div>
                          <div class="best" [ngClass]="{'mini':currentDisplay == 'both'}">{{ (lgm.is_gpp == "Y") ? lgm.tour_rank : lgm.team_rank
                            }}
                            of
                            {{(lgm.is_gpp == "Y") ? lgm.tour_entrants : lgm.entrants }}</div><br *ngIf="currentDisplay == 'both'" />
                          <div class="winning" [ngClass]="{'mini':currentDisplay == 'both'}">
                            {{(lgm.payout > 0)?'$'+lgm.payout.toFixed(2):''}}
                          </div>
                          <div class="myFpts" [ngClass]="{'mini':currentDisplay == 'both'}">
                            {{lgm?.team_total.toFixed(2)}} FPTS
                          </div>
                          <div class="pmr" [ngClass]="{'mini':currentDisplay == 'both'}"
                            *ngIf="lgm.game_id != 5 && lgm?.duration_id != 8">
                            <div class="pmrOuter">
                              <div class="pmrInner" [ngStyle]="getPMRStyle(lgm.pmr,lgm.total_pmr)"></div>
                              <div class="pmrNub"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <div class="loading" *ngIf="contest?.type == 'tournament' && contest?.loading">
                      <img src="assets/images/loading.gif">
                    </div>
                  </ng-container>
                </ng-container>
                  <ng-container *ngIf="currentTab=='drafting'">
                  <div *ngIf="displayActiveContests.length==0" class="no-record">
                    No active draft running
                  </div>
                  <ng-container *ngFor="let acontest of displayActiveContests">
                    <a class="upcoming" [routerLink]="'/draft/'+acontest.league_id">
                      <div class="gameIcon"
                        [ngStyle]="{'backgroundImage':'url(\''+(darkMode?acontest.imgUrl.replace('.png','-dark.png'):acontest.imgUrl)+'\')'}"></div>
                      <div class="uName" [ngClass]="{'mini':currentDisplay == 'both'}">
                        {{acontest?.team_name}}
                        <br>
                        {{acontest?.league_name}}</div>
                        <div class="goto text" [ngStyle]="{'line-height':(acontest.is_active && (acontest.is_paused == 'N' || acontest.is_paused == 0))?'20px':'40px'}"
                [ngClass]="{'pick':isMyPick(acontest),'warning':(isMyPick(acontest) && acontest.time_left < 25 && acontest.time_left > 10), 'danger': (isMyPick(acontest) && acontest.time_left <= 10)}">
                <span *ngIf="acontest.is_active && (acontest.is_paused == 'N' || acontest.is_paused == 0)">{{acontest.clock}}<br></span>
                <span>{{ showMessage(acontest)}}</span></div>
                    </a>
                  </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="!isMobile && currentDisplay == 'left'">
                  <div class="fullContestList">
                    <div class="contestListingHeader" *ngIf="currentTab != 'upcoming'">
                      <div class="headers">
                        <div class="name head" (click)="sortContests('name')">Contest</div>
                        <div class="contestType head" (click)="sortContests('type')">Type</div>
                        <div class="entries head" (click)="sortContests('entries')">Entries</div>
                        <div class="winning head" (click)="sortContests('winning')">Winning</div>
                        <div class="fpts head" (click)="sortContests('fpts')">FPTS</div>
                        <div class="pmr head" (click)="sortContests('pmr')">PMR</div>
                        <div class="place head" (click)="sortContests('place')">Place</div>
                        <div class="entrants head" (click)="sortContests('entrants')">Entrants</div>
                        <div class="entry head" (click)="sortContests('fee')">Entry Fee</div>
                      </div>
                    </div>
                    <div class="empty" *ngIf="!displayContests.length && !loadingContests">
                      No {{currentTab}} contests
                    </div>
                    <div class="loadingContests" *ngIf="loadingContests">
                      <img src="assets/images/loading.gif">
                    </div>
                    <ng-container *ngFor="let contest of displayContests">
                      <div class="league" *ngIf="contest?.type == 'league'" (click)="loadContest(contest?.slug)">
                        <div class="name">
                          <img [src]="bucketURL+games[contest?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1'" class="inlineGame">
                          {{contest?.lg_name}}
                        </div>
                        <div class="contestType">{{getContestType(contest)}}</div>
                        <div class="entries">1</div>
                        <div class="winning">${{contest?.payout | number:'1.2-2' | Price}}</div>
                        <div class="fpts">{{contest?.team_total|number:'1.0-2'}}</div>
                        <div class="pmr">{{(contest?.duration_id == 8)?'--':contest?.pmr}}</div>
                        <div class="place">{{contest?.team_rank}}</div>
                        <div class="entrants">{{contest?.entrants}}</div>
                        <div class="entry">${{contest?.lg_fee | number:'1.2-2' | Price}}</div>
                      </div>
                      <div class="tournament" *ngIf="contest?.type == 'tournament'"
                        (click)="(contest?.lgms == null)?expandTour(contest):(contest.expanded = !contest.expanded)"
                        [ngClass]="{'selected':contest?.expanded}">
                        <div class="name">
                          <img [src]="bucketURL+games[contest?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1'" class="inlineGame">
                          {{contest?.name}}
                          <i class="fas" [ngClass]="{'fa-caret-down':!contest?.expanded, 'fa-caret-up':contest?.expanded}"></i>
                        </div>
                        <div class="contestType">{{getContestType(contest)}}</div>
                        <div class="entries">{{contest?.lgm_ids.length}}</div>
                        <div class="winning">${{contest?.winning | number:'1.2-2' | Price}}</div>
                        <div class="fpts">{{contest?.team_total|number:'1.0-2'}}</div>
                        <div class="pmr">{{(contest?.duration_id == 8)?'--':contest?.pmr}}</div>
                        <div class="place">{{contest?.best}}</div>
                        <div class="entrants">{{contest?.tour_entrants}}</div>
                        <div class="entry">${{contest?.lg_fee | number:'1.2-2' | Price}}</div>
                      </div>
                      <ng-container *ngIf="contest?.type == 'tournament' && contest?.expanded && contest?.lgms.length">
                        <div class="lgm" *ngFor="let lgm of contest?.lgms" (click)="loadContest(lgm.slug)">
                          <div class="name">{{lgm.team_name}}</div>
                          <div class="contestType">&nbsp;</div>
                          <div class="entries">&nbsp;</div>
                          <div class="winning">${{lgm.payout | number:'1.2-2' | Price}}</div>
                          <div class="fpts">{{lgm.team_total|number:'1.0-2'}}</div>
                          <div class="pmr">{{(contest?.duration_id ==8)?'--':lgm.pmr}}</div>
                          <div class="place">{{lgm.tour_rank}}</div>
                          <div class="entrants">{{lgm.tour_entrants}}</div>
                          <div class="entry">${{contest?.lg_fee | number:'1.2-2' | Price}}</div>
                        </div>
                      </ng-container>
                      <div class="loading" *ngIf="contest?.type == 'tournament' && contest?.loading">
                        <img src="assets/images/loading.gif">
                      </div>
                      <a class="upcoming" *ngIf="contest?.type == 'upcoming'" [href]="contestLink(contest)">
                        <div class="uc">
                          <img [src]="bucketURL+games[contest?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1'" class="inlineGame">
                          {{contest?.lg_name}}
                          <i class="right fas fa-chevron-right"></i>
                        </div>
                      </a>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
        </div>
    </div>
    <div class="middlePart"
      [ngClass]="{'expanded':currentDisplay == 'right'}" *ngIf="currentDisplay != 'left'">
      <div class="contestInfo">
        <div class="heading">
          
          <a class="lgName" [href]="contestLink(contest?.data)">
            <div class="header-gameIcon" *ngIf="!isMobile"
          [ngStyle]="{'backgroundImage':'url(\''+bucketURL+games[contest?.data?.game_id]+'_icon'+darkMode_ext+'.svg?v=1.1\')'}">
          </div>
          <div class="contestname">
            {{contest?.data?.lg_name}}</div></a>
          <!-- <div class="right"></div> -->
        </div>
        
      <div class="contestHeader" [ngClass]="{'mobile':isMobile}">
     
        <div class="back" *ngIf="currentDisplay == 'right'" (click)="back()">
          <i class="fas fa-chevron-left"></i>
        </div>
        <!--<div class="rank">
          {{(contest?.data?._tour_id > 0)?contest?.data?.tour_rank:contest?.data?.team_rank | number}}<div class="pretty">
          {{prettyEnd(showRank(contest,contest?.data))}}</div>
          <div class="of">
          of {{showEntrants(contest,contest?.data) | number}}
          </div>
          </div> -->
        <div class="noContest" *ngIf="contest?.status == null">
          Please select a contest to view.
        </div>
        <div class="name" [ngStyle]="{'padding-left':(isMobile)?'5px':'0px'}">
          <div class="user">
            <div class="leagueLinks" *ngIf="!isMobile">
              <a href="javascript:void(0);" (click)="loadContest(contest?.data?.slug, false, true)" [ngClass]="{'active' : !showLgBoard}">Lineup</a>
              <a [href]="contestLink(contest?.data)">View League</a>
              <ng-container *ngIf="contest?.data?.draft_type < 4">
                <a [href]="draftLink(contest?.data)">View Draft</a>
              </ng-container>
              <a href="javascript:void(0);" (click)="openLeague(contest.data.league_id,contest.data._tour_id)">Contest Details</a>
              <ng-container *ngIf="contest?.data?.duration_id == 8 && contest?.data?.team_total > 0">
                <a href="javascript:void(0);" (click)="weekMatrix(contest?.data)">Scoring Summary</a>
              </ng-container>
              <a href="javascript:void(0);" (click)="openLgBoard(contest.data.league_id,contest.data._tour_id)" [ngClass]="{'active' : showLgBoard}">League Board<span class="newBadge2">New</span></a>
              <a href="javascript:void(0);" (click)="matchUp(contest?.data)">Matchup<span class="newBadge2">New</span></a>
            </div>
          </div>
        </div>
      <!--
        <div class="pmr" *ngIf="!isMobile && contest?.data?.duration_id != 8">
          <div class="title">{{contest?.data?.pmrText}}</div>
          <div class="pmrOuter" *ngIf="contest?.data?.game_id != 5">
            <div class="pmrInner" [ngStyle]="getPMRStyle(contest?.data?.pmr,contest?.data?.total_pmr)"></div>
            <div class="pmrNub"></div>
          </div>
          <div class="total" [ngClass]="{'pga':contest?.data?.game_id == 5}">{{contest?.data?.pmr}}</div>
        </div>
        <div class="fpts">
          {{contest?.data?.team_total | number:'1.0-2'}}
          <div class="title">{{contest?.data?.fptsText}}</div>
        </div>
        <div class="fpts">
          <div class="amount"> {{(contest?.data?._tour_id > 0)?contest?.data?.tour_rank:contest?.data?.team_rank |
            number}}{{prettyEnd(showRank(contest,contest?.data))}}
          </div>
          <div class="title">Rank</div>
        </div>
        -->
        <!-- <div class="winning" *ngIf="!isMobile">
          <div class="winningUp" *ngIf="contest?.data?.winningIncrease">$</div>
          <div class="winningDown" *ngIf="contest?.data?.winningDecrease">$</div>
          <div class="amount">${{contest?.data?.payout | number:'1.2-2'| Price}}</div>
          <div class="title">Winning</div>
        </div> -->
      
      </div>
      </div>
      <div class="contest">
        <div class="mobileTabs" *ngIf="isMobile">
          <mat-tab-group [(selectedIndex)]="mobileTabsIndex"
            (selectedTabChange)="mobileTabsChange($event,contest?.data)">
            <mat-tab class="tab" label="Team"></mat-tab>
            <mat-tab class="tab" label="Standings"></mat-tab>
            <mat-tab class="tab" label="League"></mat-tab>
            <mat-tab class="tab" *ngIf="contest?.data?.draft_type < 4" label="Draft"></mat-tab>
            <mat-tab class="tab" *ngIf="!showLgBoard" label="League Board" (click)="openLgBoard(contest.data.league_id,contest.data._tour_id)"></mat-tab>
          </mat-tab-group>
        </div>
        <div class="mobileDetails" *ngIf="isMobile">
          <div class="body">
            <div class="winning" *ngIf="isMobile">Winning: <span
                class="amount">${{contest?.data?.payout | number:'1.2-2' | Price}}</span>
            </div>
            <div id="standingsCheckboxes" *ngIf="showStandings">
              <mat-checkbox class="myEntries" [(ngModel)]="myEntries">My Entries
              </mat-checkbox>
              <mat-checkbox class="fullStandings" [(ngModel)]="mrFullStandings"
                *ngIf="contest?.data?._tour_id > 0 && contest?.data?.is_gpp == 'N'">Full Tournament</mat-checkbox>
            </div>
            <div class="pmr" *ngIf="isMobile && contest?.data?.duration_id != 8">{{contest?.data?.pmr}}
              {{contest?.data?.pmrText}}</div>
            <div class="bbFilter"
              *ngIf="isMobile && !showStandings && contest?.data?.weekSlider != null && contest?.data?.weekSlider.length">
              <mat-form-field>
                <mat-select [(value)]="contest.data.selectedWeek" (selectionChange)="changeWeek()">
                  <mat-option *ngFor="let choice of contest?.data?.weekSlider" [value]="choice.value">
                    {{choice.label}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="lineup" *ngIf="(!showStandings || currentDisplay == 'both') && !showLgBoard">
          <div class="heading">
            <div class="teamname-group">
              <div class="teamname">{{contest?.data?.team_name}} </div> 
              <div class="winningUp" *ngIf="contest?.data?.winningIncrease">$</div>
              <div class="winningDown" *ngIf="contest?.data?.winningDecrease">$</div>
              <div class="amount">${{contest?.data?.payout | number:'1.2-2'| Price}}</div>
            </div>
            
          <div class="bbFilter leftMar">
            <mat-form-field *ngIf="!isMobile && contest?.data?.weekSlider != null && contest?.data?.weekSlider.length">
              <mat-select [(value)]="contest.data.selectedWeek" (selectionChange)="changeWeek()">
                <mat-option *ngFor="let choice of contest?.data?.weekSlider" [value]="choice.value">{{choice.label}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <span class="material-symbols-outlined photo_camera" (click)="downloadImage()" *ngIf="request_left==0">
              photo_camera
              </span> -->
          </div>
          </div>
          <div class="statsofuser">
            <div class="points">
              <p class="svalue">{{contest?.data?.team_total|number:'1.0-2'}}</p>
              <p class="slabel">Points</p>
            </div>
            <div class="place"> 
              <p class="svalue" *ngIf="!isLoading">{{prettyPrint(contest?.data?._tour_id != 0?contest?.data?.tour_rank:contest?.data?.team_rank)}} </p>
              <p class="slabel">Place</p>
            </div>
            <div class="weekpos">
              <p class="svalue">{{contest?.data?.this_week|number:'1.0-2'}}</p>
              <p class="slabel">This week</p>
            </div>
              <div class="advofuser">
                <p class="svalue amount">
                  ${{contest?.data?.payout | number:'1.2-2' | Price}}
                </p>
                <p class="slabel">Winning</p>
              </div>
          </div>
          <mat-error *ngIf="errorMsg!=''" class="error">{{errorMsg}}</mat-error>
          <div class="players scrollTable" #players [ngStyle]="{'height':getHeight(players)+'px'}">
            <ng-container *ngFor="let player of contest?.data?.players">
              <div class="player" [ngClass]="{'move':player.move_swap == 1, 'drop':player.move_cnf == 1, 'moving':player.move_undo == 1,'usedBackGroundOther':contest?.data?.duration_id !=8,'usedBackGround':player?.use == true}"
                (click)="showMobStats(player)" >
                <div class="position" [ngStyle]="{'color':getRGBAColor(player?.color_code)}">
                  {{(contest?.data?.draft_type == 4)?(player.pn + 'X'):((positions[player.pick_rp] ==
                  null)?player.pick_rp:positions[player.pick_rp])}}
                  </div>
                <div class="headshot" *ngIf="!isMobile" [ngStyle]="{'background-image':'url(\''+playerURL+player.pic+'?v='+imgversion+'\')'}"></div>
                <div class="details">
                  <div class="name" [ngClass]="{'strike':player.elim == 1}" (click)="openPlayerInfoBox(player,player.id,$event)">
                    {{printPlayerName(player)}}</div>
                  <!-- <div class="team">{{player.tn}}</div> -->
                  <div class="status" *ngIf="contest?.data?.game_id != 5">
                    <div class="item" *ngFor="let item of player.result" [ngClass]="{'bold-font':item.bold == '1','regular-font':item.bold != '1'}" >
                      {{item.label}}&nbsp;</div>
                  </div>
                  <div class="status" *ngIf="contest?.data?.game_id == 5">
                    <div class="item">
                      {{player.detail}}
                    </div>
                  </div>
                  </div>
                  <div class="stats"
                    *ngIf="!isMobile && player.stats != null && player.stats.length && !showSwaps(player) && !player.is_proj">
                    <div class="stat" *ngFor="let stat of player.stats;let i = index;">
                      <ng-container *ngIf="stat.value != 0">
                        {{stat.value|number:'1.0-2'}} <span class="title">{{stat.key}}</span><span
                          *ngIf="i < player.stats.length-1">,&nbsp;</span>
                      </ng-container>
                    </div>
                  </div>
                  <div class="swapMove" *ngIf="!isMobile && !showStandings && showSwaps(player)">
                    <!-- [href]="getSwapLink(player,contest)" -->
                    <a (click)="showPlayersForSwap(player,contest,null)" mat-stroked-button class="button" *ngIf="player.is_swap == 1"><i
                        class="fas fa-exchange-alt icon"></i>
                      Swap</a>
                  <button mat-stroked-button class="button" *ngIf="player.is_move == 1" (click)="clickMove(player,contest)"><i
                      class="fas fa-arrows-alt-v icon"></i>
                    Move</button>
                  <div class="spacer" *ngIf="player.is_swap == 1 && player.is_move == 0"></div>
                  <button mat-stroked-button class="button" *ngIf="player.move_cnf == 1" (click)="confirmDrop(player,contest)"><i
                      class="fas fa-user-minus icon"></i>
                    Move + Drop</button>
                  <button mat-stroked-button class="button" *ngIf="player.move_swap == 1" (click)="movePlayers(player,contest)"><i
                      class="fas fa-arrow-circle-down icon"></i>
                    Move Here</button>
                  <button mat-stroked-button class="button" *ngIf="player.move_undo == 1"
                    (click)="loadContest(contest?.data?.slug, false, true)"><i class="fas fa-undo icon"></i>
                    Cancel</button>
                </div>
                <div class="mobileExpand"
                  *ngIf="isMobile && player.stats != null && player.stats.length && !showSwaps(player) && !player.is_proj">
                  <i [ngClass]="{'fa-chevron-down':!player.showStats, 'fa-chevron-up':player.showStats}" class="fas"></i>
                </div>
              <div class="" [ngClass]="{'fire':player.hot == 1, 'ice':player.cold== 1}" >
                <p style="height: 32px;width:32px"></p>
              </div>
                <div class="fpts" [ngClass]="{'isproj':player.is_proj}">
                  <div class="upArrow" *ngIf="player.fptsIncrease"><i class="fas fa-arrow-up"></i></div>
                  <div class="downArrow" *ngIf="player.fptsDecrease"><i class="fas fa-arrow-down"></i></div>
                  {{(player.is_proj ? player.projFpts : (player.events[0]["fptsText"]||0))}}
                  <div class="title"></div>
                  <!-- <div class="title">{{(player.is_proj)?'PROJ':fptsText(contest?.data,player)}}</div> -->
                </div>
                </div>
                <div class="statsline" *ngIf="isMobile && player.stats != null && player.showStats">
                  <div class="stat" *ngFor="let stat of player.stats;let i = index;">
                    <ng-container *ngIf="stat.value != 0">
                      {{stat.value|number:'1.0-2'}} <span class="title">{{stat.key}}</span><span
                        *ngIf="i < player.stats.length-1">,&nbsp;</span>
                    </ng-container>
                  </div>
                </div>
                <div class="swapMoveMob" *ngIf="isMobile && showSwaps(player)">
                    <a (click)="showPlayersForSwap(player,contest,null)" mat-stroked-button class="button" *ngIf="player.is_swap == 1"><i
                      class="fas fa-exchange-alt icon"></i>
                    Swap</a>
                  <button mat-stroked-button class="button" *ngIf="player.is_move == 1" (click)="clickMove(player,contest)"><i
                      class="fas fa-arrows-alt-v icon"></i>
                    Move</button>
                  <div class="spacer" *ngIf="player.is_swap == 1 && player.is_move == 0"></div>
                  <button mat-stroked-button class="button" *ngIf="player.move_cnf == 1" (click)="confirmDrop(player,contest)"><i
                      class="fas fa-user-minus icon"></i>
                    Move + Drop</button>
                  <button mat-stroked-button class="button" *ngIf="player.move_swap == 1" (click)="movePlayers(player,contest)"><i
                      class="fas fa-arrow-circle-down icon"></i>
                    Move Here</button>
                  <button mat-stroked-button class="button" *ngIf="player.move_undo == 1"
                    (click)="loadContest(contest?.data?.slug, false, true)"><i class="fas fa-undo icon"></i>
                    Cancel</button>
                </div>
                </ng-container>
          </div>
        </div>
        <div class="lineup lg-board" *ngIf="showLgBoard">
          <app-newsfeed lgId="{{lgId}}" tourId="{{tourId}}" pageName="lgProfile"></app-newsfeed>
        </div>
      </div>
    </div>
    <div class="rightSide" [ngStyle]="{'flex':(isMobile)?'100%':'','width':isMobile?'100%':'max-height:100vh'}" [ngStyle]="{'height':getHeight(sLeftContainer)+'px'}">
      <app-standings *ngIf="currentDisplay != 'both'" [contest]="contest"
          [mrFullStandings]="mrFullStandings" [myEntries]="myEntries" [user]="user" [season]="selectedSeason"
          (loadContestEmit)="loadContest($event, true)">
        </app-standings>
      <div class="standingsContainer" #standingsContainer *ngIf="!isMobile">
      <div class="standingsSlide heading">Overall Standings
          <!-- <mat-checkbox class="myEntries right" >Show Only Mine</mat-checkbox>  -->
          <div class="shhowmine" >
            <div class="textSOY">Show Only <br>Your Entries</div>
          <mat-slide-toggle class="radioSOY" [(ngModel)]="myEntries"></mat-slide-toggle></div>
        </div>
      <div class="standingsBody">
        <app-standings [contest]="contest" [mrFullStandings]="mrFullStandings"  [season]="selectedSeason"
          [myEntries]="myEntries" [user]="user" (loadContestEmit)="loadContest($event, true)">
        </app-standings>
        <ng-container *ngIf="!isMobile || (isMobile && currentDisplay == 'left')">
          <div class="full-tournament-sec" *ngIf="!isMobile && contest?.data?._tour_id > 0 && contest?.data?.is_gpp == 'N'">           
            <div class="textSOY">Full Tournament &nbsp;</div>
            <mat-slide-toggle class="radioSOY" [(ngModel)]="mrFullStandings"></mat-slide-toggle>
          </div>
        </ng-container>
      </div>
    </div>
    </div>
  </div>
</div>
<div class="loadingOverlay" *ngIf="isLoading">
  <img src="assets/images/loadinganim.gif">
</div>
<div id="download">
    <img #canvasForSS src="" [ngStyle]="{'display':showCanvasSS==true?'none':'none'}" />  
    <a #downloadLinkForSS></a>
</div>
<div class="middlePart screenshorpart" [ngStyle]="{'display':showCanvasSS==true?'block':'none'}" style="padding-top:600px">
  <div class="contest">
        <div class="lineup" #screenToCapture>
                  <div class="heading">
                    <div class="teamname-group">
                      <div class="teamname">{{contest?.data?.team_name}} <br>
                    <span class="leagename">{{contest?.data?.lg_name}}</span></div>
                    </div>
                    <div class="bbFilter leftMar">
                      <img *ngIf="darkMode" style="width:80px;" [src]="imageData[logoUrlDark]?imageData[logoUrlDark]:'assets/images/logo.png'" alt="">
                      <img *ngIf="!darkMode" style="width:80px;" [src]="imageData[logoUrl]?imageData[logoUrl]:'assets/images/logo-red.png'" alt="">
                    </div>
                  </div>
                    <div  class="players" [ngStyle]="{'height':'auto'}"  style="overflow-y: unset;">
                    <div class="statsofuser">
                      <div class="points">
                        <p class="svalue">{{contest?.data?.team_total|number:'1.0-2'}}</p>
                        <p class="slabel">Points</p>
                      </div>
                      <div class="place"> 
                        <p class="svalue">{{prettyPrint(contest?.data?._tour_id != 0?contest?.data?.tour_rank:contest?.data?.team_rank)}}</p>
                        <p class="slabel">Place</p>
                      </div>
                      <div class="weekpos">
                        <p class="svalue">{{contest?.data?.this_week|number:'1.0-2'}}</p>
                        <p class="slabel">This week</p>
                      </div>
                        <div class="advofuser">
                          <p class="svalue amount">
                            ${{contest?.data?.payout | number:'1.2-2' | Price}}
                          </p>
                          <p class="slabel">Winning</p>
                        </div>
                    </div>

                      <ng-container *ngFor="let player of contest?.data?.players">
                        <div class="player"
                          [ngClass]="{'move':player.move_swap == 1, 'drop':player.move_cnf == 1, 'moving':player.move_undo == 1,'usedBackGroundOther':contest?.data?.duration_id !=8,'usedBackGround':player?.use == true}"
                          (click)="showMobStats(player)" >
                          <div class="position" [ngStyle]="{'color':getRGBAColor(player?.color_code)}">
                            {{(contest?.data?.draft_type == 4)?(player.pn + 'X'):((positions[player.pick_rp] ==
                            null)?player.pick_rp:positions[player.pick_rp])}}
                            </div>
                          <div  style="height:52px;" [ngStyle]="{'width':(contest?.data?.game_id == 3?'55px':(contest?.data?.game_id == 5 || contest?.data?.game_id == 4 || contest?.data?.game_id == 1?'70px':'60px')),'margin':contest?.data?.game_id == 3?'-2px 0px 4px 0px':''}">
                            <img class="" [ngStyle]="{'width':(contest?.data?.game_id == 3?'55px':(contest?.data?.game_id == 5 || contest?.data?.game_id == 4 || contest?.data?.game_id == 1?'70px':'52px'))}" style="border-radius: 50%;" [src]="imageData[playerImgFolder+player.pic]?imageData[playerImgFolder+player.pic]:playerURL+player.pic"/>
                          </div>
                          <div class="details">
                            <div class="name" [ngClass]="{'strike':player.elim == 1}" (click)="openPlayerInfoBox(player,player.id,$event)">
                              {{printPlayerName(player)}}</div>
                            <!-- <div class="team">{{player.tn}}</div> -->
                            <div class="status" *ngIf="contest?.data?.game_id != 5">
                              <div class="item" *ngFor="let item of player.result" [ngClass]="{'bold-font':item.bold == '1','regular-font':item.bold != '1'}" >
                                {{item.label}}&nbsp;</div>
                            </div>
                            <div class="status" *ngIf="contest?.data?.game_id == 5">
                              <div class="item">
                                {{player.detail}}
                              </div>
                            </div>
                            </div>
                            <!-- <div class="stats"
                              *ngIf="player.stats != null && player.stats.length && !showSwaps(player) && !player.is_proj">
                              <div class="stat" *ngFor="let stat of player.stats;let i = index;">
                                <ng-container *ngIf="stat.value != 0">
                                  {{stat.value|number:'1.0-2'}} <span class="title">{{stat.key}}</span><span
                                    *ngIf="i < player.stats.length-1">,&nbsp;</span>
                                </ng-container>
                              </div>
                            </div> -->                      
                          <div class="fpts" [ngClass]="{'isproj':player.is_proj}">
                            {{((player.is_proj)?player.projFpts:player.fpts) | number:'1.0-2'}}
                            <div class="title">{{((player.is_proj)?'Proj':'')}}</div>
                          </div>
                          </div>
                          </ng-container>
                    </div>
        </div>
  </div>
</div>